module.exports = __webpack_public_path__ + "d664201f/img/settings-icon.121d9519.svg";